export default "__VITE_ASSET__Bh94VTWh__"